export default __webpack_public_path__ + "static/media/truy-cung-giet-tan-cuoc-tai-ngo-cua-hai-ong-hoang-phong-ve-xu-han-15966122361852.5ca49090.png";